import type { Theme } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

import { ThemeProvider as V5ThemeProvider } from '@mui/material/styles';
import { useCallback } from 'react';

import type { IPenThemes } from '../theme/customTheme';

type Props = {
  themeId: IPenThemes;
};

export const IpenThemeProvider: FC<PropsWithChildren<Props>> = ({
  children,
  themeId,
}) => {
  const v5Theme = useCallback(
    (base: Theme) => {
      const theme = base.getIpenThemeOfPage(themeId).getTheme('v5') as Theme;
      const pageTheme = base.getPageTheme({ themeId });
      return {
        ...base,
        ...theme,
        page: pageTheme,
      };
    },
    [themeId],
  );
  return <V5ThemeProvider<Theme> theme={v5Theme}>{children}</V5ThemeProvider>;
};
